import algosdk from 'algosdk';
import { algodClient } from './algo';

export async function getSuggestedParams() {
  return await algodClient.getTransactionParams().do();
}

export async function waitForConfirmation(txnID) {
  await algosdk.waitForConfirmation(algodClient, txnID, 200);
}
